
<div class="site-panel v-flex" style="border-bottom-style: solid; border-bottom-width: 1px; border-radius: 0" v-if="site">
    <v-row class="no-frame">
        <v-col class="main-first-col modal-tab no-border ma-0 mr-1">
            <v-row class="no-frame">
                <c-assessment-card-iterator
                    :assessments = "assessments"
                    @selected    = "onSelected"
                    class        = "w-100 maintenance-column pb-1"
                />
            </v-row>
        </v-col>
        <v-col class="main-middlle-last-col modal-tab no-border ma-0 mr-1 pr-3">
            <v-row class="no-frame" v-if="selected">
                <c-column-header label="Meldung" class="primary w-100 mt-2" />
                <div v-if="selected.documents && selected.documents[0]">

                </div>
                <c-dms-viewer
                    v-if="selected.documents && selected.documents[0]"
                    style="height: calc(100% - 44px); margin-top: 0;"
                    :document = "selected.documents[0].id"
                />
            </v-row>
        </v-col>
        <v-col class="main-last-col modal-tab no-border ma-0 pl-0">
            <v-row class="no-frame"  v-if="selected">
                <c-column-header
                    label="Mängelliste"
                    class="primary w-100 mt-2"
                />
                <div class=" mt-1 mb-3 w-100 maintenance-column">
                    <div v-if="selected" class="lm-border pa-3 w-100 " style="height: 797px;">
                        <div
                            v-for="(fault, index) in selected.faults"
                            :key="index"
                        >
                            <div class="v-flex mb-4">
                                <div
                                    class  = "fault-rating"
                                    :class = "color(fault)"
                                >
                                    {{ ratingName(fault.rating) }}
                                </div>

                                <v-textarea
                                    v-model        = "fault.description"
                                    rows           = "6"
                                    class          = "mt-0 pt-0 pr-1"
                                    ref            = "description"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    no-resize
                                    hide-details
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </v-row>
        </v-col>
    </v-row>
</div>
